export enum SessionStorageKeys {
  TaftConfig = 'TAFT_CONFIG',
  OcidConfig = 'OIDC_CONFIG',
  AppConfig = 'APP_CONFIG',
}

export enum RouteName {
  VerifyEmail = 'verifyEmail',
  Ministry = 'ministry',
  Main = 'main',
  Reports = 'reports',
  Logout = 'logout',
  Dashboard = 'dashboard',
  TaskList = 'task-list',
}

export enum FuelHelperTypes {
  FuelSheet = 'sheet',
  FuelCalculator = 'calc',
}

export enum TransactionFilterTypes {
  Teller = 'teller',
  DateRange = 'date-range',
  ProductType = 'product-type',
  TransactionType = 'transaction-type',
  Retailer = 'retailer',
  Age = 'age',
  UpdatedTransactions = 'updated-transactions',
  Cardholder = 'cardholder',
}

export enum TransactionTypes {
  All = 'all',
  Online = 'online',
  Offline = 'offline',
  Overlimit = 'overlimit',
  BandDiscount = 'band-discount',
}

export enum Months {
  January,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December,
}

export const InputRegex = {
  Amount: /[0-9]+([.])?([0-9]{1,2})?/,
  Litres: /[0-9]+([.])?([0-9]{1,3})?/,
};

export enum TaftKeycloakRoles {
  TAFT_RETAILER_WEBAPP_POS = 'taft_retailer_webapp_pos',
  TAFT_RETAILER_WEBAPP_REPORTS = 'taft_retailer_webapp_reports',
  TAFT_MINISTRY_REPORTS = 'taft_ministry_reports',
  TAFT_MINISTRY_CITIZEN_REPORTS = 'taft_ministry_citizen_report',
  TAFT_MINISTRY_TASKS = 'taft_ministry_tasks',
  TAFT_MINISTRY_TASKS_PENDING_STATUS_NUMBERS = 'taft_ministry_tasks_pending_status_numbers'
}

export const SupportContactNumber = '(778) 433-1268 (Ext. 121)';

export const MinistryContactNumber = '(250) 387-9115';

export const TobaccoTaxEmail = 'TobaccoTax@gov.bc.ca';
